<template>
  <div class="btn-background white-wrapper mt-3" @click="showHoroscope">
    <div class="title">
      Гороскоп<br />
      на {{ today }}
    </div>

    <img src="../../assets/horoscope/sun.png" />
  </div>
</template>

<script>
import {today} from "@/lib/utils";

export default {
  name: "HoroscopeButton",
  methods: {
    showHoroscope() {
      this.$root.$emit('showHoroscope');
    },
  },
  computed: {
    today() {
      return today();
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
  line-height: 1.1;
  font-size: 18px;
  color: white;
}

.btn-background {
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background-color: #4158D0;
  background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);

  & img {
    position: absolute;
    left: 75%;
    top: -35px;
    z-index: 1;
  }
}
</style>